import SEO from "../components/seo.jsx"
import { useRef, useState } from "react";
import counsellorImg from "../assets/facility/counsellor.jpeg";
import technicalTeamImg from "../assets/facility/technicalTeam.png";
import otImg from "../assets/facility/ot.png";

const cinzel = { fontFamily: "'Cinzel', serif" };

/* ─────────────────────────────────────────────
   👉 ONLY CHANGE THIS BLOCK FOR EACH NEW BRANCH 👈
───────────────────────────────────────────── */
const branchData = {
  name: "Shirdi",
  address: [
    "Near Shirsath hospital,",
    "kacheri cross road,ward no.1,",
    "Shrirampur- 413709,",
    "Dist. Ahmednagar",
  ],
  phones: ["(+91) 9082123009"],
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3758.13755338386!2d74.6616559!3d19.6214162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdc8b7c1c0a3f53%3A0x5138ab28307d79cc!2sDr%20Thakur%27s%20Nexgen%20Dental%20Clinic%20-%20Dental%20Implant%20Centre%20in%20Shrirampur%2C%20Dental%20Clinic%20Near%20me%2C%20Root%20canal%20in%20Shrirampur!5e0!3m2!1sen!2sin!4v1782115073671!5m2!1sen!2sin",
};
/* ───────────────────────────────────────────── */

const facilities = [
  { img: counsellorImg, label: "Dedicated Medical Counsellor" },
  { img: technicalTeamImg, label: "Senior Technical Team" },
  { img: otImg, label: "Well Equipped OT" },
]

/* ─────────────────────────────────────────────
   SUCCESS/ERROR POPUP COMPONENT
───────────────────────────────────────────── */
function ResponseModal({ type, message, onClose }) {
  if (!message) return null;

  const isSuccess = type === "success";

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className={`relative w-full max-w-md rounded-2xl overflow-hidden shadow-2xl transform transition-all ${
          isSuccess ? "bg-[#f2ece0]" : "bg-red-50"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top accent bar */}
        <div
          className={`h-1 ${isSuccess ? "bg-gradient-to-r from-[#c9a84c] to-[#ffe9a0]" : "bg-red-400"}`}
        />

        {/* Icon + Content */}
        <div className="p-8 text-center">
          {isSuccess ? (
            <>
              {/* Success Icon */}
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-[#c9a84c]/15 border-2 border-[#c9a84c] flex items-center justify-center animate-pulse">
                  <svg
                    className="w-8 h-8 text-[#c9a84c]"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                  </svg>
                </div>
              </div>

              <h2 style={cinzel} className="text-[1.6rem] font-black text-[#1a0f02] mb-2 tracking-[0.04em]">
                Thank You!
              </h2>
              <p className="text-[14px] text-[#6b5535] leading-[1.7]">
                Your enquiry has been submitted successfully. Our team will get in touch with you shortly.
              </p>
            </>
          ) : (
            <>
              {/* Error Icon */}
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-red-100 border-2 border-red-400 flex items-center justify-center">
                  <svg
                    className="w-8 h-8 text-red-500"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                </div>
              </div>

              <h2 style={cinzel} className="text-[1.6rem] font-black text-red-600 mb-2 tracking-[0.04em]">
                Oops!
              </h2>
              <p className="text-[14px] text-red-700 leading-[1.7]">{message}</p>
            </>
          )}
        </div>

        {/* Close Button */}
        <div className="px-8 pb-6">
          <button
            onClick={onClose}
            style={{
              ...cinzel,
              backgroundImage: isSuccess
                ? "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)"
                : "linear-gradient(135deg,#dc2626,#ef4444,#dc2626)",
              backgroundSize: "200% 100%",
            }}
            className="w-full text-[11px] font-bold tracking-[0.16em] uppercase px-6 py-3 rounded-md text-white hover:-translate-y-0.5 hover:shadow-lg transition-all"
          >
            {isSuccess ? "Got It" : "Try Again"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function BranchPage({ url = "https://shirdi.hairclinique.in/shirdi.php" }) {
  const formRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [responseType, setResponseType] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");

const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    const form = new FormData(formRef.current);

    const data = {
      name: form.get("name"),
      email: form.get("email"),
      phone: form.get("mobile"),
      message: form.get("message"),
      branch: branchData.name.toLowerCase(),
    };

    try {
      const response = await fetch(
        "https://ibl4onv4t5.execute-api.ap-south-1.amazonaws.com/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setResponseType("success");
        setResponseMessage(
          "Your enquiry has been submitted successfully. Our team will get in touch with you shortly."
        );
        formRef.current.reset();
      } else {
        setResponseType("error");
        setResponseMessage(
          result.message || "Failed to send enquiry. Please try again."
        );
      }
    } catch (error) {
      console.error(error);
      setResponseType("error");
      setResponseMessage(
        "Something went wrong. Please check your connection and try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setResponseType(null);
    setResponseMessage("");
  };

  return (
    <>
    <SEO
  title="Hair Transplant in Shirdi | Dr. Idris - Clinique Internationale"
  description="Visit Clinique Internationale's Shirdi branch for advanced Sapphire FUE hair transplant and hair restoration treatments with Dr. Idris. Book your consultation today."
  url={url}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      <div className="relative mt-20 w-full bg-[#f2ece0] overflow-hidden font-['Raleway',sans-serif]">

        {/* ═══════════════════ BREADCRUMB HERO ═══════════════════ */}
        <div className="relative h-[220px] sm:h-[260px] md:h-[300px] flex items-center justify-center overflow-hidden bg-[#0e0905]">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0e0905]/70 to-[#0e0905]/90" />
          <div className="relative z-10 text-center px-6">
            <p style={cinzel} className="text-[11px] tracking-[0.3em] uppercase text-[#c9a84c] mb-4 flex items-center justify-center gap-2.5">
              <span className="w-7 h-px bg-[#c9a84c]" />
              Visit Us
              <span className="w-7 h-px bg-[#c9a84c]" />
            </p>
            <h1 style={cinzel} className="font-black text-[1.8rem] sm:text-[2.3rem] md:text-[2.8rem] tracking-[0.04em] uppercase text-white mb-3">
              {branchData.name} Branch
            </h1>
            <div style={cinzel} className="flex items-center justify-center gap-2.5 text-[12px] tracking-[0.08em] uppercase text-white/60">
              <span className="text-white/85">Home</span>
              <span className="text-[#c9a84c]">/</span>
              <span className="text-[#c9a84c]">{branchData.name}</span>
            </div>
          </div>
        </div>

        {/* ═══════════════════ CONTACT INFO + FORM ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 py-16 sm:py-20 md:py-24 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">

          {/* LEFT: Contact Info */}
          <div>
            <div className="mb-9">
              <h3 style={cinzel} className="text-[15px] font-bold tracking-[0.12em] uppercase text-[#1a0f02] mb-3">
                Address :
              </h3>
              <span className="block w-10 h-px bg-[#c9a84c] mb-3" />
              <p className="text-[14px] leading-[1.9] text-[#6b5535]">
                {branchData.address.map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            </div>


            <div>
              <h3 style={cinzel} className="text-[15px] font-bold tracking-[0.12em] uppercase text-[#1a0f02] mb-3">
                Phones :
              </h3>
              <span className="block w-10 h-px bg-[#c9a84c] mb-3" />
              <p className="text-[14px] text-[#a07828] font-medium leading-[1.9]">
                {branchData.phones.map((ph, i) => (
                  <span key={i}>
                    <a href={`tel:${ph.replace(/[^\d+]/g, "")}`} className="hover:text-[#1a0f02] transition-colors">
                      {ph}
                    </a>
                    {i < branchData.phones.length - 1 && " ; "}
                  </span>
                ))}
              </p>
            </div>
          </div>

          {/* RIGHT: Contact Form */}
          <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-4">
            <label className="flex items-center gap-3 bg-white rounded-md px-5 py-4 border border-[#c9a84c]/20">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a07828" strokeWidth="1.6"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
              <input disabled={isLoading} required type="text" name="name" placeholder="Your name" className="w-full bg-transparent outline-none text-[14px] text-[#1a0f02] placeholder:text-[#9a8a6a]" />
            </label>

            <label className="flex items-center gap-3 bg-white rounded-md px-5 py-4 border border-[#c9a84c]/20">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a07828" strokeWidth="1.6"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>
              <input disabled={isLoading} required type="email" name="email" placeholder="Your e-mail" className="w-full bg-transparent outline-none text-[14px] text-[#1a0f02] placeholder:text-[#9a8a6a]" />
            </label>

            <label className="flex items-center gap-3 bg-white rounded-md px-5 py-4 border border-[#c9a84c]/20">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a07828" strokeWidth="1.6"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 015 6a2 2 0 012-2z"/></svg>
              <input disabled={isLoading} required type="tel" name="mobile" placeholder="Your Mobile Number" className="w-full bg-transparent outline-none text-[14px] text-[#1a0f02] placeholder:text-[#9a8a6a]" />
            </label>

            <label className="flex items-start gap-3 bg-white rounded-md px-5 py-4 border border-[#c9a84c]/20">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#a07828" strokeWidth="1.6" className="mt-0.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
              <textarea disabled={isLoading} required name="message" placeholder="Your message" rows="4" className="w-full bg-transparent outline-none text-[14px] text-[#1a0f02] placeholder:text-[#9a8a6a] resize-none" />
            </label>

<button
              type="submit"
              disabled={isLoading}
              style={{
                ...cinzel,
                backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)",
                backgroundSize: "200% 100%",
              }}
              className="mt-2 text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] cursor-pointer transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] hover:bg-right self-start disabled:opacity-70 disabled:cursor-not-allowed disabled:-translate-y-0"
            >
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        {/* ═══════════════════ FACILITY STRIP ═══════════════════ */}
        <div className="bg-white py-14 sm:py-16">
          <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {facilities.map((f, i) => (
              <div key={i} className="text-center">
                <div className="rounded-lg overflow-hidden mb-4 shadow-[0_4px_16px_rgba(0,0,0,0.08)]">
                  <img src={f.img} alt={f.label} className="w-full h-[180px] sm:h-[200px] object-cover" />
                </div>
                <p style={cinzel} className="text-[13px] sm:text-[14px] font-semibold uppercase tracking-[0.04em] text-[#1a0f02]">
                  {f.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════════════════ LIVE GOOGLE MAP ═══════════════════ */}
        <div className="w-full h-[380px] sm:h-[440px] md:h-[480px]">
          <iframe
            src={branchData.mapEmbedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={`${branchData.name} Branch Location`}
          />
        </div>

      </div>
      <ResponseModal
  type={responseType}
  message={responseMessage}
  onClose={closeModal}
/>
    </>
  );
}